import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { DomainsSection } from './components/DomainsSection';
import { GallerySection } from './components/GallerySection';
import { AboutSection } from './components/AboutSection';
import { HospitalitySection } from './components/HospitalitySection';
import { ClientReviewsSection } from './components/ClientReviewsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { QuoteSection } from './components/QuoteSection';
import { PressSection } from './components/PressSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <IntroSection />
      <DomainsSection />
      <GallerySection />
      <AboutSection />
      <HospitalitySection />
      <ClientReviewsSection />
      <QuoteSection />
      <TestimonialsSection />
      <PressSection />
    </div>
  );
}
